export const call = require("./phone.png");
export const background = require("./logo_back.png");
export const Logo = require("./logo.png");
export const pass_un = require("./password_unview.png");
export const password_view = require("./password_view.png");
export const person = require("./humanFill.png");
export const reminder = require("./reminder.png");
export const reminder_1 = require("./reminder_1.png");
export const person2 = require("./person2.png");
export const back_icon = require("./back.png");
export const back_icon1 = require("./back1.png");
export const counting = require("./icon_counting.png");
export const vector = require("./Vector.png");
export const side_bar = require("./dashboard_1.png");
export const admin = require("./admin.png");
export const recharge = require("./recharge.png");
export const history = require("./history.png");
export const withdraw = require("./withdraw.png");
export const announce = require("./announce.png");
export const friends = require("./friends.png");
export const links = require("./links.png");
export const daily_result = require("./daily-result.png");
export const winning = require("./winning.png");
export const wallet = require("./wallet.png");
export const right = require("./right.png");
export const left = require("./left.png");
export const notification = require("./notification.png");
export const notificationW = require("./notificationW.png");
export const notificationP = require("./notificationP.png");

export const announcement = require("./announcement.png");
export const overall = require("./overall.png");
export const report = require("./report.png");
export const link = require("./link.png");
export const apptime = require("./apptime.png");
export const help = require("./help.png");
export const logout = require("./logout.png");
export const arrow = require("./arrow.png");
export const home_active = require("./home.png");
export const client_active = require("./client.png");
export const client_inactive = require("./client_no.png");
export const recharge_active = require("./recharge_1.png");
export const recharge_inactive = require("./recharge_no.png");
export const withdraw_active = require("./withdraw_1.png");
export const withdraw_inactive = require("./withdraw_no.png");
export const report_active = require("./report_1.png");
export const report_inactive = require("./report_no.png");
export const bg = require("./bg.png");
export const fb = require("./fb.png");
export const whatsapp = require("./whatsapp.png");
export const telegram = require("./telegram.png");
export const instagram = require("./insta.png");
export const calender_icon = require("./calender.png");
export const rightArrow = require("./rightArrow.png");

export const gpay = require("./gpaybg.png");
export const paytm = require("./paytmbg.png");
export const phonepay = require("./phonepebg.png");
export const otherbg = require("./otherbg.png");

export const HomeBar = require("./homeGray.png");
export const RechargeBar = require("./rechargeBar.png");
export const PricelistBar = require("./pricelistBar.png");
export const CartBar = require("./CartBar.png");
export const Profilebar = require("./profileBar.png");

export const homeGreen = require("./HomeGreen.png");
export const rechargeGreen = require("./rechargeGreen.png");
export const pricelistGreen = require("./priceGreen.png");
export const CartGreen = require("./cartGreen.png");
export const profileGreen = require("./profileGreen.png");

export const copyIcon = require("./copyIcon.png");
export const qrImage = require("./qrImage.png");
export const cart2 = require("./cart2.png");
export const homebg = require("./homebg.png");
export const greenbell = require("./greenbell.png");
export const banner1 = require("./banner1.png");
export const banner2 = require("./banner2.png");
export const LOTTERY1 = require("./LOTTERY1.png");
export const LOTTERY2 = require("./LOTTERY2.png");

export const resultNumber = require("./resultNumber.png");
export const resultBf = require("./resultBf.png");
export const closedDear = require("./closedDear.png");
export const closedKerala = require("./closedKerala.png");
export const iButton = require("./iButton.png");
export const priceDoc = require("./priceDoc.png");
export const support = require("./support.png");

export const ibutton2 = require("./ibutton2.png");
export const blurBg = require("./blurBg.png");
export const deleteIcon = require("./delete.png");

export const accWallet = require("./accWallet.png");
export const eyeOpen = require("./eyeOpen.png");
export const eyeClose = require("./eyeClose.png");
export const countryArr = require("./countyArr.png");
